module.exports = __webpack_public_path__ + "static/img/role.cc5d7f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/bz/role.png
// module id = v+mm
// module chunks = 7